import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import App from "./components/App";
import { TaskpaneServicesProvider } from "@src/load-agent/app/TaskpaneServicesContext";
import "./taskpane.css";

initializeIcons();
Office.onReady(() => {
  const container = document.getElementById("container");

  if (container) {
    const root = ReactDOM.createRoot(container);

    root.render(
      <TaskpaneServicesProvider>
        <App />
      </TaskpaneServicesProvider>
    );
  }
});
